import React, { Dispatch, useRef, useEffect } from 'react';
import '../App.css';
import { useDrop } from 'react-dnd'
import { IInject, IScenario, ITurnBrief } from '../interfaces';
import { Inject } from '../Classes1';
import { ItemTypes } from '../ItemTypes'

interface TurnProps {
    setInjectComponents: Dispatch<any>;
    setInjectItem: Dispatch<any>;
    injectItem: IInject;
    injectComponents: IInject[];
    turn: number;
    greedy: boolean;
    updateShowHide: Dispatch<any>;
    clickBranches: Dispatch<any>;
    gameTimeInterval: number;
    setZoomLevel: Dispatch<any>;
    zoomLevel: number;
    scenSnippets: ITurnBrief[];
    setSnippetModalIsOpen: Dispatch<any>;
    setSelectedSnippet: Dispatch<any>;
    selectedScenario: IScenario;
  }

  export interface InjectState {
    hasDropped: boolean
    hasDroppedOnChild: boolean;
  }

const Turn: React.FC<TurnProps> = ({ setInjectComponents, injectComponents, turn, greedy, updateShowHide, setInjectItem, injectItem, clickBranches, gameTimeInterval, setZoomLevel, zoomLevel, scenSnippets, setSnippetModalIsOpen, setSelectedSnippet, selectedScenario }) => {

    const injectComponentsRef = useRef<IInject[]>([])
    useEffect(() => {
        injectComponentsRef.current = injectComponents;
    });

    /*** DnD Drop Inject in Turn Code */
    const [{ isOverCurrent }, drop] = useDrop(
        () => ({
          accept: [ItemTypes.INJECT],
          drop(_item: any, monitor) {
            const didDrop = monitor.didDrop()
            if (didDrop && !greedy) {
              return
            }
              if (parseInt(_item.turn) === turn) {
                return;
              }

              let isInj: boolean = false;
              let isId: string = '0';
              let tempInjects: Inject[] = JSON.parse(JSON.stringify(injectComponentsRef.current));
              injectComponentsRef.current.forEach((inj: IInject) => {
                if (inj.id === undefined || _item.id === undefined) {

                } else {
                  if (inj.id === _item.id.toString()) {
                    isInj = true;
                    isId = inj.id;
                  }
                }
              })

              if (!isInj) {
                let injObj: any = {};
                injObj.id = (injectComponentsRef.current.length + 1).toString();
                injObj.injectId = '';
                injObj.turnLength = 1;
                injObj.name = 'Inject' + injectComponentsRef.current.length + 1;
                injObj.startTurn = turn;
                
                injObj.turnOrder = 0;
                injObj.isNew = true;
                injObj.nodes = []
                let newInject = new Inject(injObj)
                tempInjects.push(newInject)
              } else {
                tempInjects = tempInjects.map((inject) => {
                  if (inject.id === isId) {
                      return { ...inject, startTurn: turn, isNew: true };
                  } else {
                      return inject;
                  }
                })
              }

              if (!isInj) {
                setInjectComponents([
                  ...injectComponentsRef.current,
                  tempInjects.filter((inj: IInject) => inj.isNew === true)
                ]);
              } else {
                let tempInjComps: IInject[] = JSON.parse(JSON.stringify(injectComponentsRef.current));
                for (let i = 0; i<tempInjComps.length; i++) {
                  if (tempInjComps[i].id === isId) {
                    let trnInj: any = getTurnInjects(_item);
                    let newInj: IInject[] = trnInj.filter((inj: IInject, isId: string) => inj.id === isId)
                    tempInjComps[i].startTurn = newInj[0].startTurn;
                    tempInjComps[i].turnOrder = newInj[0].turnOrder;
                  }
                }

                setInjectComponents(tempInjComps)
              }
          },
            collect: (monitor) => ({
              isOver: monitor.isOver(),
              isOverCurrent: monitor.isOver({ shallow: true }),
              canDrop: monitor.canDrop(),
            })
        }),
        [greedy]
      )

      let borderRight = '1px dashed #fff'
      let border = 'inherit'

      if (isOverCurrent) {
        border = '2px solid #3F83FC'
        borderRight = '2px solid #3F83FC'
      }

    const getTurnInjects = (inItem: any) => {
      console.log("getTurnInjects")
      let isInj: boolean = false;
      let isId: string = '0';
      let tempInjects: Inject[] = JSON.parse(JSON.stringify(injectComponentsRef.current));
      injectComponentsRef.current.forEach((inj: IInject) => {
        if (inj.id === undefined || inItem.id === undefined) {

        } else {
          if (inj.id === inItem.id.toString()) {
            isInj = true;
            isId = inj.id;
          }
        }
      })

      if (!isInj) {
        let injObj: any = {};
        injObj.id = (injectComponentsRef.current.length + 1).toString();
        injObj.injectId = '';
        injObj.turnLength = 1;
        injObj.name = 'Inject' + injectComponentsRef.current.length + 1;
        injObj.startTurn = turn;
        
        injObj.turnOrder = 0;
        injObj.isNew = true;
        injObj.nodes = []
        let newInject = new Inject(injObj)
        tempInjects.push(newInject)
      } else {
        tempInjects = tempInjects.map((inject) => {
          if (inject.id === isId) {
              return { ...inject, startTurn: turn, isNew: true };
          } else {
              return inject;
          }
        })
      }
      let turnInjects1: IInject[] = [];
              
      for (let i = 0; i<tempInjects.length; i++) {
        if (tempInjects[i].startTurn < turn && ((tempInjects[i].startTurn + tempInjects[i].turnLength-1) >= turn) && tempInjects[i].startTurn !== turn) {
          // insert phantom inject
          let newInj: IInject = new Inject({});
          newInj.id = 'empty'+i;
          newInj.name = 'empty';
          newInj.isEmpty = true;
          newInj.startTurn = turn;
          newInj.turnLength = 1;
          newInj.turnOrder = tempInjects[i].turnOrder
          turnInjects1.push(newInj)
        }
        if (tempInjects[i].startTurn === turn) {
          turnInjects1.push(tempInjects[i])
        }
      }

      // Find first open inject slot in this turn
      // Max number of slots

      let slotsInjects: Inject[] = JSON.parse(JSON.stringify(injectComponentsRef.current));

      let turnsGrid: any[] = [];

      for (let i = 0; i<gameTimeInterval; i++) {
          let turnObj: any = {};
          turnObj.turn = i+1;
          turnObj.lowestAvail = 1;
          turnObj.highestTaken = 1;
          turnObj.injects = [];
          turnsGrid.push(turnObj)
      } 

      for (let k = 0; k<turnsGrid.length; k++) {
        for (let l = 0; l<slotsInjects.length; l++) {
          if (turnsGrid[k].turn === slotsInjects[l].startTurn) {
            turnsGrid[k].injects.push(slotsInjects[l])
          }
        }
      }

      for (let k = 0; k<turnsGrid.length; k++) {
        for (let l = 0; l<turnsGrid[k].injects.length; l++) {
          if (turnsGrid[k].injects[l].turnLength > 1) {
            // insert empty injects in future turns
            let startTurn: number = turnsGrid[k].injects[l].startTurn;
            for (let m = 0; m<turnsGrid.length; m++) {
              if (turnsGrid[m].turn === startTurn+1 && turnsGrid[m].turn < (turnsGrid[k].injects[l].startTurn + turnsGrid[k].injects[l].turnLength)) {
                let emptyInj: any = {};
                emptyInj.id = 'turnextended'
                emptyInj.turnOrder = turnsGrid[k].injects[l].turnOrder;
                turnsGrid[m].injects.push(emptyInj)
                startTurn++;
              }
            }
          }
        }
      }

      for (let k = 0; k<turnsGrid.length; k++) {
        let turnOrders: number[] = [];
        for (let l = 0; l<turnsGrid[k].injects.length; l++) {
          // get all turnorders
          turnOrders.push(turnsGrid[k].injects[l].turnOrder)
        }

        turnsGrid[k].highestTaken = turnOrders.length === 0 ? 0 : Math.max(...turnOrders)
        if (turnsGrid[k].highestTaken === 1) {
          turnsGrid[k].lowestAvail = 2;
        } else {
          for (let m = 1; m<turnsGrid[k].highestTaken+1; m++) {
            if (turnsGrid[k].injects.length === 0) {
              turnsGrid[k].lowestAvail = 1
            }
          }
        }
      }

      for (let m = 0; m<turnsGrid.length; m++) {
        let notAvail: number[] = [];
        
        for (let o = 0; o<turnsGrid[m].highestTaken; o++) {
            // not taken and not available
            let found: boolean = false;
            for (let n = 0; n<turnsGrid[m].injects.length; n++) {
              if ((o+1) === turnsGrid[m].injects[n].turnOrder) {
                found = true;
              }
            }
            if (!found) {
              notAvail.push(o+1)
            }
          }
          turnsGrid[m].notAvail = notAvail;
      }

      for (let m = 0; m<turnsGrid.length; m++) {
        for (let n = 0; n<turnsGrid[m].notAvail.length; n++) {
          let ghostInj: any = {};
          ghostInj.id = 'ghost'
          ghostInj.turnOrder = turnsGrid[m].notAvail[n];
          ghostInj.startTurn = turn;
          turnsGrid[m].injects.push(ghostInj)
          if (turnsGrid[m].turn === turn) {
            turnInjects1.push(ghostInj)
          }
        }
      }

      let turnInjTurnOrders: number[] = []
      for (let i = 0; i<turnInjects1.length; i++) {
        turnInjTurnOrders.push(turnInjects1[i].turnOrder)
      }

      for (let i = 0; i<turnInjects1.length; i++) {
        if (turnInjects1[i].isNew) {
          turnInjects1[i].turnOrder = Math.max(...turnInjTurnOrders)+1
        }
      }

      return turnInjects1;
    }

    /*** DnD Drop Inject in Turn Code End */
    return (
        <div ref={drop} data-testid={`timeline${turn}`} className={`turn turn${turn}`} style={{ 'border': border, borderRight: borderRight }}>
          <div className="turn-label">Turn {turn}</div>
        </div>
    )
}

export default Turn;